var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{"close__drawer_bbat": !_vm.drawer},attrs:{"id":"app_user_profile"}},[(false)?_c('v-navigation-drawer',{attrs:{"app":"","clipped":"","floating":"","width":"310"}}):_vm._e(),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }